export enum ActionTypesAppealResponses {
  SET_APPEAL_RESPONSES_DATA = 'SET_APPEAL_RESPONSES_DATA',
  RESET_APPEAL_RESPONSES = 'RESET_APPEAL_RESPONSES',
  SET_LOADING_INDICATOR = 'SET_LOADING_INDICATOR',
  SHOW_APPEAL_RESPONSES_GRID = 'SHOW_APPEAL_RESPONSES_GRID',
  SET_RECONSIDERATION_DROPDOWNS = 'SET_RECONSIDERATION_DROPDOWNS',
  TOGGLE_RECONSIDERATION_DROPDOWNS_LOADING = 'TOGGLE_RECONSIDERATION_DROPDOWNS_LOADING',
}
export const APPEAL_RESPONSES_SEARCH_INPUT_PLACEHOLDER = 'Search by';
export const APPEAL_RESPONSES_GRID_TITLE = 'Appeal Responses';
export const APPEAL_RESPONSES_GRID_RECORD_MESSAGE = 'No records to display at this time.';
export const APPEAL_RESPONSES_GRID_COLUMNS = new Set([
  {
    dataName: 'appealResponseId',
    text: 'Response Id',
    sortable: true,
    isSorted: 0,
    headerWidth: 80,
    isHeaderTruncated: true,
    // width: '200px',
  },
  {
    dataName: 'response',
    text: 'Response',
    sortable: true,
    isSorted: 0,
    headerWidth: 300,
    isHeaderTruncated: true,
    // width: '500px',
  },
  {
    dataName: 'responseDescription',
    text: 'Response Description',
    sortable: true,
    isSorted: 0,
    headerWidth: 500,
    isHeaderTruncated: true,
    // width: '180px',
  },
  {
    dataName: 'appealType',
    text: 'Appeal Type',
    sortable: true,
    isSorted: 0,
    headerWidth: 100,
    isHeaderTruncated: true,
    // width: '130px',
  },
  {
    dataName: 'recommendation',
    text: 'Recommendation',
    sortable: true,
    isSorted: 0,
    headerWidth: 180,
    isHeaderTruncated: true,
    // width: '130px',
  },
  {
    dataName: 'statusChip',
    text: 'Status',
    sortable: true,
    cellType: 'chip',
    isSorted: 0,
    headerWidth: 80,
    isHeaderTruncated: true,
  },
  {
    dataName: 'sequence',
    text: 'Sequence',
    sortable: true,
    isSorted: 0,
    headerWidth: 60,
    isHeaderTruncated: true,
  },
]);

export const STATUS_DROPDOWN = [
  { label: 'Inactive', value: 0 },
  { label: 'Active', value: 1 },
];
